import React, { useState } from 'react'
import Button from '@material-ui/core/Button'
import AccountsBenefitModal from 'components/account-benefits-modal'
import { redirectToLogin, redirectToSignup } from 'lib/auth'
import { FormCard } from './form-parts'
import useStyles from './styles'

// Shown to visitors who cannot book as a guest (guest booking is off, or the
// offering is a lesson pack). Same actions as the legacy
// `CreateAccountForBookingLayout`: log in, create an account, or read the
// account benefits.
const AccountRequiredPanel = () => {
  const classes = useStyles()
  const [benefitsOpen, setBenefitsOpen] = useState(false)

  return (
    <>
      <FormCard
        title="Log in to continue"
        subtitle={
          <>
            Log into your MyPGA account to complete booking this session.{' '}
            <button
              type="button"
              className={classes.linkButton}
              onClick={() => setBenefitsOpen(true)}
            >
              Learn more
            </button>
          </>
        }
      >
        <div className={classes.actionsAccount}>
          <Button
            type="button"
            variant="contained"
            color="primary"
            className={classes.submitButton}
            onClick={() => redirectToLogin('consumer')}
          >
            Log in
          </Button>
          <Button
            type="button"
            variant="outlined"
            color="primary"
            className={classes.outlinedButton}
            onClick={() => redirectToSignup('consumer')}
          >
            Create account
          </Button>
        </div>
      </FormCard>
      <AccountsBenefitModal isOpen={benefitsOpen} setIsOpen={setBenefitsOpen} />
    </>
  )
}

export default AccountRequiredPanel
